import React from "react"
import { StaticQuery, graphql } from "gatsby"

import Card from "@components/card"
import { HeadingThree } from "@components/type"

const LinCard = ({ colour }) => (
  <StaticQuery
    query={graphql`
      query {
        file(relativePath: { eq: "home/neil-lin.jpg" }) {
          childImageSharp {
            fluid(maxWidth: 475) {
              ...GatsbyImageSharpFluid
            }
          }
        }
      }
    `}
    render={data => (
      <Card image={data.file.childImageSharp.fluid}>
        <HeadingThree colour={colour}>Neil Lin</HeadingThree>
        <p>
          Neil is a vigilant and devoted volunteer, who has contributed over 100
          volunteer hours by the end of the 2018-19 school year
        </p>
      </Card>
    )}
  />
)

export default LinCard
